import { render, staticRenderFns } from "./CorpServiceManagement.vue?vue&type=template&id=3ae33479&scoped=true"
import script from "./CorpServiceManagement.vue?vue&type=script&lang=js"
export * from "./CorpServiceManagement.vue?vue&type=script&lang=js"
import style0 from "./CorpServiceManagement.vue?vue&type=style&index=0&id=3ae33479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae33479",
  null
  
)

export default component.exports